var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nut-price",domProps:{"innerHTML":_vm._s(_vm.priceShow)}},[_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }